import LocalStorageService from "../LocalStorageService";
import NonceService from "./NonceService";

export interface ISession {
  accountId: string;
  apiKey: string;
  authToken: string;
  companyName: string;
  email: string;
  nonces: string[];
  userId: string;
}

/**
 * Service class for saving and retrieving various session data.
 */
abstract class SessionService {
  public static clearSession = () =>
    NonceService.clearNonces().then(() => {
      window.localStorage.clear();
    });

  public static getAccountId = () => LocalStorageService.getAccountId();

  public static getApiKey = () => LocalStorageService.getApiKey();

  public static getAuthToken = () => LocalStorageService.getAuthToken();

  public static getCompanyName = () => LocalStorageService.getCompanyName();

  public static getEmail = () => LocalStorageService.getEmail();

  public static getNonce = () => NonceService.getNonce();

  public static getUserId = () => LocalStorageService.getUserId();

  public static getIsLoggedfromLS = () => LocalStorageService.getIsLoggedfromLS();

  public static hasSession = () => localStorage.length !== 0;

  public static setSession = ({
    accountId,
    apiKey,
    authToken,
    companyName,
    email,
    nonces,
    userId
  }: ISession) =>
    NonceService.saveNonces(nonces).then(() => {
      LocalStorageService.setAccountId(accountId);
      LocalStorageService.setApiKey(apiKey);
      LocalStorageService.setAuthToken(authToken);
      LocalStorageService.setCompanyName(companyName);
      LocalStorageService.setEmail(email);
      LocalStorageService.setUserId(userId);
      LocalStorageService.setIsLoggedfromLS('true');
    });
}

export default SessionService;
